import { Warning2, Cross } from '@/components/icons';
import { Button } from '@/components/ui/button';
import type { PublishIssue } from '../types';

interface PublishReadinessPanelProps {
    issues: PublishIssue[];
    onClose: () => void;
}

export function PublishReadinessPanel({ issues, onClose }: PublishReadinessPanelProps) {
    if (issues.length === 0) return null;

    return (
        <section className="mx-auto mb-6 max-w-5xl rounded-2xl border border-warning/25 bg-warning-subtle/70 px-4 py-3 text-warning-foreground shadow-sm sm:px-5">
            <div className="flex items-start gap-3">
                <Warning2 className="mt-0.5 size-5 shrink-0" />
                <div className="min-w-0 flex-1">
                    <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
                        <p className="text-sm font-semibold">
                            {issues.length} ajuste(s) antes de publicar
                        </p>
                    </div>
                    <ul className="mt-2 space-y-1 text-xs leading-relaxed">
                        {issues.slice(0, 5).map((issue) => (
                            <li key={issue.id}>{issue.message}</li>
                        ))}
                        {issues.length > 5 ? (
                            <li>Mais {issues.length - 5} ajuste(s) pendente(s).</li>
                        ) : null}
                    </ul>
                </div>
                <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    className="-mr-2 -mt-2 size-8 shrink-0 text-warning-foreground/70 hover:text-warning-foreground"
                    onClick={onClose}
                    aria-label="Fechar aviso"
                >
                    <Cross className="size-4" />
                </Button>
            </div>
        </section>
    );
}
